import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoutes = () => {
  const token = localStorage.getItem("company_token");

  if (!token) {
    // Redirect to the login page if not logged in
    return <Navigate to="/organizations/signin" replace />;
  }

  // Render all child routes if logged in
  return <Outlet />;
};

export default ProtectedRoutes;
